import React, { useState } from 'react'
import styles from './modal.module.css'
import { Box, Button, IconButton, InputAdornment, MenuItem, Select, TextField } from '@mui/material'
import ClearIcon from '@mui/icons-material/Clear';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import ModalCalendar from './ModalCalendar';
import dayjs from 'dayjs'
import moment from 'moment/moment'
import * as api from '../../pages/services/api'

function ModalExportHealthAssessment({ onClose }) {

    const [loading, setLoading] = useState(false)
    const [assessment, setAssessment] = useState(null)

    const [openCalendar, setOpenCalendar] = useState(false)
    const [disabledDay, setDisabledDay] = useState([])
    const [typeDate, setTypeDate] = useState('')
    const [dateStart, setDateStart] = useState(dayjs(moment(new Date()).startOf('month').format('YYYY-MM-DD')))
    const [dateEnd, setDateEnd] = useState(dayjs(moment(new Date()).endOf('month').format('YYYY-MM-DD')))

    const handleClickDate = (type) => {
        setTypeDate(type)
        setOpenCalendar(true)
    }

    const convertDate = (dataDate) => {
        const date = new Date(dataDate)
        const optionDate = {
            year: 'numeric',
            month: 'long',
            day: 'numeric',
        }
        const thaiLocale = 'th-TH';
        const formattedDate = date.toLocaleDateString(thaiLocale, optionDate)

        const newDate = `${formattedDate}`
        return newDate
    }

    const handleClickExportCSV = () => {
        if (!assessment) {
            alert('กรุณาเลือกแบบประเมินที่ต้องการ')
            return
        }

        if (assessment === 'แบบประเมินสุขภาพใจ') {
            mentalHealth()
        } else {
            healthBehaviorSurvey()
        }
    }

    const healthBehaviorSurvey = async () => {
        setLoading(true)
        let res = await api.healthBehaviorSurvey(moment(new Date(dateStart)).format('YYYY-MM-DD'), moment(new Date(dateEnd)).format('YYYY-MM-DD'))
        setLoading(false)
        if (res) {
            if (res['data']['code'] === 200) {
                console.log('แบบประเมินพฤติกรรมสุขภาพ', res['data']['data'])
                let data = res['data']['data']['file_url']
                window.open(data, '_blank')
            } else {
                console.log(res['data']['message'])
            }
        } else {
            alert('ไม่ตอบสนอง')
        }
    }

    const mentalHealth = async () => {
        setLoading(true)
        let res = await api.mentalHealth(moment(new Date(dateStart)).format('YYYY-MM-DD'), moment(new Date(dateEnd)).format('YYYY-MM-DD'))
        setLoading(false)
        if (res) {
            if (res['data']['code'] === 200) {
                console.log('แบบประเมินสุขภาพใจ', res['data']['data'])
                let data = res['data']['data']['file_url']
                window.open(data, '_blank')
            } else {
                console.log(res['data']['message'])
                //alert(res['data']['message'])
            }
        } else {
            alert('ไม่ตอบสนอง')
        }
    }

    return (
        <>
            {openCalendar &&
                <ModalCalendar
                    onClose={() => { setOpenCalendar(false) }}
                    onSubmit={() => {
                        setOpenCalendar(false)
                    }}
                    value={
                        typeDate === 'start' ?
                            dateStart ? dayjs(moment(dateStart['$d']).format('YYYY-MM-DD')) : dayjs(moment(new Date()).format('YYYY-MM-DD'))
                            :
                            dateEnd ? dayjs(moment(dateEnd['$d']).format('YYYY-MM-DD')) : dayjs(moment(new Date()).format('YYYY-MM-DD'))
                    }
                    setValue={(e) => {
                        typeDate === 'start' ? setDateStart(e) : setDateEnd(e)
                    }}
                    disableDay={disabledDay}
                />
            }
            <Box className={styles.backgroundModal2}>
                <Box className={styles.boxModal2}>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <Box sx={{ display: 'flex', gridGap: '10px' }}>
                            <Box sx={{ border: '5px solid #478F96' }} />
                            <Box sx={{
                                fontWeight: 600,
                                fontSize: '18px',
                                color: '#478F96',
                                "@media (max-width: 800px)": {
                                    fontSize: '16px',
                                }
                            }}>Export</Box>
                        </Box>
                        <Box sx={{ '&:hover': { cursor: 'pointer' } }}>
                            <IconButton onClick={() => { onClose() }}>
                                <ClearIcon />
                            </IconButton>
                        </Box>
                    </Box>

                    <Box sx={{
                        display: 'grid',
                        gridGap: '15px'
                    }}>
                        <Box sx={{ display: 'grid', gridGap: '20px' }}>
                            <Box>
                                <Box>เลือกแบบประเมินที่ต้องการ</Box>
                                <Select
                                    fullWidth
                                    size='small'
                                    value={assessment || 'null'}
                                    onChange={(e) => { setAssessment(e.target.value) }}
                                >
                                    <MenuItem value='null' disabled>เลือกแบบประเมิน</MenuItem>
                                    <MenuItem value='แบบประเมินสุขภาพใจ'>แบบประเมินสุขภาพใจ</MenuItem>
                                    <MenuItem value='แบบประเมินพฤติกรรมสุขภาพ'>แบบประเมินพฤติกรรมสุขภาพ</MenuItem>
                                </Select>
                            </Box>
                        </Box>

                        <Box sx={{
                            display: 'flex',
                            gridGap: '10px',
                            "@media (max-width: 800px)": {
                                display: 'grid'
                            },
                        }}>
                            <Box>
                                <Box>เลือกวันที่เริ่ม</Box>
                                <TextField
                                    fullWidth
                                    size='small'
                                    sx={{ ...SelectCss }}
                                    value={dateStart === '' ? 'เลือกวันที่เริ่ม' : convertDate(dateStart)}
                                    InputProps={{
                                        inputProps: {
                                            readOnly: true,
                                        },
                                        endAdornment: (
                                            <InputAdornment position="end">
                                                <IconButton
                                                    onClick={() => { handleClickDate('start') }}
                                                >
                                                    <CalendarTodayIcon />
                                                </IconButton>
                                            </InputAdornment>
                                        )
                                    }}
                                />
                            </Box>
                            <Box>
                                <Box>เลือกวันที่สิ้นสุด</Box>
                                <TextField
                                    fullWidth
                                    size='small'
                                    sx={{ ...SelectCss }}
                                    value={dateEnd === '' ? 'เลือกวันที่สิ้นสุด' : convertDate(dateEnd)}
                                    InputProps={{
                                        inputProps: {
                                            readOnly: true,
                                        },
                                        endAdornment: (
                                            <InputAdornment position="end">
                                                <IconButton
                                                    onClick={() => { handleClickDate('end') }}
                                                >
                                                    <CalendarTodayIcon />
                                                </IconButton>
                                            </InputAdornment>
                                        )
                                    }}
                                />
                            </Box>
                        </Box>

                        <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                            <Button
                                variant='contained'
                                onClick={() => { handleClickExportCSV() }}
                            >Export</Button>
                        </Box>
                    </Box>

                </Box>
            </Box>
        </>
    )
}

const SelectCss = {
    backgroundColor: '#C8EBEB',
    border: 'none',
    '.MuiOutlinedInput-notchedOutline': {
        borderColor: '#C8EBEB',
    },
    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
        borderColor: '#C8EBEB',
    },
    '&:hover .MuiOutlinedInput-notchedOutline': {
        borderColor: '#C8EBEB',
    },
}

export default ModalExportHealthAssessment
